import * as M from "@discovery/prelude/lib/data/maybe";
import { ms2Hmmss } from "@discovery/roadie";
export const toDuration = (durationM) => {
    return M.map((value) => ms2Hmmss(value), durationM);
};
export const parseMillisecondsIntoReadableHours = (durationM, viewingHistoryM) => {
    const duration = M.fromMaybe(durationM, 0);
    const positionM = M.map((viewingHistory) => {
        return M.fromMaybe(viewingHistory.position, 0);
    }, viewingHistoryM);
    const position = M.fromMaybe(positionM, 0);
    const timeLeft = duration - position;
    const hours = timeLeft / (1000 * 60 * 60);
    const absoluteHours = Math.floor(hours);
    const h = absoluteHours > 9 ? absoluteHours : "0" + absoluteHours;
    return h;
};
export const parseMillisecondsIntoReadableMin = (durationM, viewingHistoryM) => {
    //Get remainder from hours and convert to minutes
    const duration = M.fromMaybe(durationM, 0);
    const positionM = M.map((viewingHistory) => {
        return M.fromMaybe(viewingHistory.position, 0);
    }, viewingHistoryM);
    const position = M.fromMaybe(positionM, 0);
    const timeLeft = duration - position;
    const hours = timeLeft / (1000 * 60 * 60);
    const absoluteHours = Math.floor(hours);
    const minutes = (hours - absoluteHours) * 60;
    const absoluteMinutes = Math.floor(minutes);
    const m = absoluteMinutes > 9 ? absoluteMinutes : "0" + absoluteMinutes;
    return m;
};

